<template>
  <v-menu v-model="menuOpen" offset-y max-width="400" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon color="secondary" class="mx-2" v-bind="attrs" v-on="on">
        <v-badge :content="totalPendientes" :value="totalPendientes > 0" color="error" overlap>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card color="primary" class="card">
      <v-card-title class="d-flex justify-space-between align-center py-3">
        <span class="text-subtitle-1 font-weight-bold">Notificaciones</span>
        <v-btn icon small @click="closeMenu">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <v-list color="transparent" dense>
          <!-- Evaluación de Productividad -->
          <v-list-item v-if="evaluacionesPendientes.productividad > 0">
            <v-list-item-icon class="mr-3">
              <v-icon color="secondary">mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium"> Evaluación de Productividad </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ evaluacionesPendientes.productividad }} pendiente{{
                  evaluacionesPendientes.productividad > 1 ? 's' : ''
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip small color="warning" text-color="white">
                {{ evaluacionesPendientes.productividad }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>

          <!-- Respeto a los Principios -->
          <v-list-item v-if="evaluacionesPendientes.respetoPrincipios > 0">
            <v-list-item-icon class="mr-3">
              <v-icon color="secondary">mdi-gavel</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium"> Respeto a los Principios </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ evaluacionesPendientes.respetoPrincipios }} pendiente{{
                  evaluacionesPendientes.respetoPrincipios > 1 ? 's' : ''
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip small color="warning" text-color="white">
                {{ evaluacionesPendientes.respetoPrincipios }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>

          <!-- Evaluación Anual -->
          <v-list-item v-if="evaluacionesPendientes.evaluacionAnual > 0">
            <v-list-item-icon class="mr-3">
              <v-icon color="secondary">mdi-calendar-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium"> Evaluación Anual </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ evaluacionesPendientes.evaluacionAnual }} pendiente{{
                  evaluacionesPendientes.evaluacionAnual > 1 ? 's' : ''
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip small color="warning" text-color="white">
                {{ evaluacionesPendientes.evaluacionAnual }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>

          <!-- Convocatorias Inscritas -->
          <v-list-item v-if="convocatoriasInscritas.length > 0">
            <v-list-item-icon class="mr-3">
              <v-icon color="secondary">mdi-bullhorn</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium"> Convocatorias </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ convocatoriasInscritas.length }} inscrita{{ convocatoriasInscritas.length > 1 ? 's' : '' }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip small color="info" text-color="white">
                {{ convocatoriasInscritas.length }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>

          <!-- Sin notificaciones -->
          <v-list-item v-if="totalNotificaciones === 0">
            <v-list-item-content class="text-center py-5">
              <v-icon size="48" color="success" class="mb-3">mdi-check-circle</v-icon>
              <v-list-item-title class="text-subtitle-2"> No tienes notificaciones pendientes </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider v-if="totalNotificaciones > 0"></v-divider>

      <v-card-actions v-if="totalNotificaciones > 0" class="justify-center py-2">
        <v-btn text small color="secondary" @click="verTodasLasEvaluaciones">
          Ver todas
          <v-icon small right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'NotificacionesPoliciaMenu',

  props: {
    evaluaciones: {
      type: Object,
      required: true,
    },
    convocatorias: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      menuOpen: false,
    }
  },

  computed: {
    evaluacionesPendientes() {
      const ESTATUS_PENDIENTE = 'Evaluación Pendiente'

      return {
        productividad:
          this.evaluaciones.Productividad?.filter((ev) => ev.estatusEvaluacion === ESTATUS_PENDIENTE).length || 0,

        respetoPrincipios:
          this.evaluaciones.RespetoPrincipios?.filter((ev) => ev.estatusEvaluacion === ESTATUS_PENDIENTE).length || 0,

        evaluacionAnual:
          this.evaluaciones.EvaluacionAnual?.filter((ev) => ev.estatusEvaluacion === ESTATUS_PENDIENTE).length || 0,
      }
    },

    convocatoriasInscritas() {
      return this.convocatorias || []
    },

    totalPendientes() {
      return (
        this.evaluacionesPendientes.productividad +
        this.evaluacionesPendientes.respetoPrincipios +
        this.evaluacionesPendientes.evaluacionAnual
      )
    },

    totalNotificaciones() {
      return this.totalPendientes + this.convocatoriasInscritas.length
    },
  },

  methods: {
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),

    getNombreConvocatoria(conv) {
      return conv.Convocatoria?.convocatoria || conv.convocatoria || conv.catConvocatoria?.convocatoria || 'Sin nombre'
    },
    closeMenu() {
      this.menuOpen = false
    },

    verTodasLasEvaluaciones() {
      this.SET_SELECTED_MENU(10)
      this.menuOpen = false
    },
  },
}
</script>

<style scoped>
.notification-item {
  cursor: pointer;
  transition: background-color 0.2s;
}

.notification-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
</style>
